import { create } from "zustand";
import { v4 as uuid } from "uuid";

export type NotificationType = "error" | "info" | "success" | "warning";

export interface NotificationConfig {
    id: string;
    message: string;
    type: NotificationType;
    action?: ((ret?: any) => Promise<any>) | ((ret?: any) => void);
    actionLabel?: string;
    onClose?: (ret: any) => void;
}

export interface NotificationState {
    notifications: NotificationConfig[];
    addNotification: (
        message?: string,
        type?: NotificationType,
        action?: ((ret?: any) => Promise<any>) | ((ret?: any) => void),
        actionLabel?: string
    ) => Promise<unknown>;
}

export type NotificationService = NotificationState;

export const useNotificationState = create<NotificationState>((set, get) => ({
    notifications: [],
    addNotification: async (message = null, type = "info", action, actionLabel) => {
        const id = uuid();
        let config: NotificationConfig = null;
        const confirmed = await new Promise((resolve) => {
            config = {
                id,
                message,
                type,
                action,
                actionLabel,
                onClose: (c: boolean) => resolve(c),
            };
            set((state) => ({ notifications: [...state.notifications, config] }));
        });
        set((state) => {
            const next = [...state.notifications];
            const idx = state.notifications.findIndex((n) => n.id === id);
            if (idx >= 0) next.splice(idx, 1);
            return { notifications: next };
        });
        return confirmed;
    },
}));
